import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface BookCategoryProps {
  title: string;
  description: string;
  image: string;
  count: string;
  delay?: number;
}
export function BookCategory({
  title,
  description,
  image,
  count,
  delay = 0
}: BookCategoryProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    y: -5
  }} className="group relative overflow-hidden rounded-xl bg-white shadow-lg shadow-cyan-500/10 cursor-pointer border-2 border-transparent hover:border-cyan-400 transition-all duration-300" data-id="element-106">
      <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-107">
        <img src={image} alt={title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-108" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/50 to-transparent" data-id="element-109" />
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-110">
        <span className="mb-2 inline-block text-xs font-bold uppercase tracking-wider text-cyan-300 bg-cyan-600/80 px-2 py-1 rounded" data-id="element-111">
          {count} Libros
        </span>
        <h3 className="mb-1 text-2xl font-serif font-bold" data-id="element-112">{title}</h3>
        <p className="mb-4 text-sm text-slate-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-113">
          {description}
        </p>
        <div className="flex items-center text-sm font-bold text-cyan-300" data-id="element-114">
          Explorar colección{' '}
          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-115" />
        </div>
      </div>
    </motion.div>;
}